(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9546],{

/***/ 86737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./1.png": 22089,
	"./2.png": 48462,
	"./3.png": 11633,
	"./4.png": 86374,
	"./5.png": 52118,
	"./6.png": 33934,
	"./what-is-electronic-signature.gif": 19607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86737;

/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 38246:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/what-is-electronic-signature",
      function () {
        return __webpack_require__(93489);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/free-trial.ebab8c0d.png","height":491,"width":509,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEXs6/Hx8e37+v3r5vPn5u729fb29vv29fv6+f7x8fPy7/jj4eri4Or////9/f3w8PPv7vL6+v309PXy7/j//v/49v7Zpx2+AAAAEHRSTlP90Oxi/uol2dnkw+r9Otv1j6q45gAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEBJREFUeJwVxkkSgCAMAMFhTRC1kgD//6pln5re+5PGSKjPGrEzejALb0i9q9mfBcYaiAFE493uZ+3MNUUllfIBWQUCdH5HLUUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 22089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/1.4b34346b.png","height":688,"width":649,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEX//v+ZmKje1vatrbTu7e6lpqn6+vuzs7h0dHTz8/Pj4eXRzOZ+foOMjZLb3NzX19fGv9zAudW+v8BkZWidm57j4O4fM3SmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nAXBBwLAIAgAsUNBwNn1/7c2AbcZnynMiIhXYVn1Z3WaJQ3fFNGu+KBIZlJviuxzsl4U6a3h4wdBMAHEn8GnfQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 48462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/2.e17695c6.png","height":601,"width":687,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAY1BMVEX43vj9+v+667q14rTF3ujX8tH+5/Ts7PTk9t/Q6PLy8ffq0s3t2Nfi4fjx3/Sitbrl3+J6kZfb6dzW7PWGqYbI8sebkoy7rq6w5a+s7KzczMiyztmk3aT94+Ddxb2UzpT64dmar02UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nCXBRwLAIAgEwFVBQE3vPf9/ZQ6ZQTi5ZCHD+nC+00HwG1+v2IDJa9kTGcKoy+y6Btq3MdaVwOH3AVv2AoAYu5e5AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 11633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/3.4bb13bcc.png","height":726,"width":578,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAANlBMVEX5+vvs8/PK5rnr7PTv+fvb6/zl9/3+/v3e9f3w7/rVwfzErPzk2P3z8fXV1drg4ebg496+1qBK7r/4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nAXBiQGAMAgEwYUAB37R/pt1Bgm5w3q2fzBr7IUZbsAsECUUTV3nEU1nZtcPHbEBF0uRAFYAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 86374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/4.fc5d8e08.png","height":726,"width":629,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAP1BMVEXk5Of19ffv4d717+745+P/7Ofs7Ovx8fH8/P3z5+bTwNu6tsLSz9Pj8Pfd0+Xl2NjLvsPW4eP/8++etrbp3fuPSvJJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nBXFRxLAIAwEwUGAVkTH/7/V5b40u0tS0Pu7J4lgrWaZ4LlciTsPFJlqA49GLRNP/+dhrXw4JQGhgHPGOAAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 52118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/5.9bfeacf4.png","height":521,"width":575,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAPFBMVEX/+PTn3/zy9+jh0Pr//fr8/P/29e/o+uPx7fv69fm1kf/Rzv/Ixv+6t//z5rH54Hb568v07MT96bP965riOW1vAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nCXESRKAQAgEwQIBG7dx+f9fDcM8JLZYaNtXNHW0TAD9BVmPdwaVdY0jA6d0nw3zz18pNQFgAYA2uQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 33934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/6.ee38cc21.png","height":604,"width":611,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEX////p6O+roNC1oJ/s6ur19fju7PPw8PL7+/zJ3ejl2djBrfXmtam3r77PqKHOyd3R6vS0pdyQma/d8vrQyOOim8WUg8jLx9fPyOKVCVJIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nB3BBw7AIAwAsQtkFbr3/19aqTYkqplAmge1kiHiMc4sm7nFpJw9xK013p5OqvLcpZRrX4nhd3w77QICiTSAiwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 19607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/what-is-electronic-signature.d2980dc5.gif","height":497,"width":620});

/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 33376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const legals = [
    {
        name: "ESIGN Act",
        image: "esign.png",
        fullForm: "Electronic Signatures in Global and National Commerce Act (ESIGN)",
        description: "We ensure every electronic signature on our platform is legally binding by verifying the signer's identity and capturing their intent to sign."
    },
    {
        name: "UECA Act",
        image: "ueca-act.png",
        fullForm: "Uniform Electronic Communications Act (UECA)",
        description: "BoloSign's robust record-keeping and verification processes ensure that any electronic records related to environmental covenants are legally valid and enforceable."
    },
    {
        name: "Federal Decree Law",
        image: "federal-decree-law.png",
        fullForm: "Federal Decree-Law No. 46 of 2021 (UAE)",
        description: "We adhere to this law by implementing robust security measures and ensuring that all electronic transactions are legally binding and recognized by UAE authorities."
    },
    {
        name: "UETA Act",
        image: "ueta.png",
        fullForm: "The Uniform Electronic Transactions Act (UETA)",
        description: "BoloSign ensures clear consent from all parties to conduct business electronically, and our platform maintains robust records to validate each transaction."
    },
    {
        name: "ETL Act",
        image: "etl-act.png",
        fullForm: "Electronic Transactions Law (ETL)",
        description: "BoloSign adheres to the specific ETLs of each country where we operate, ensuring that electronic signatures are legally valid and compliant with local regulations."
    },
    {
        name: "HIPAA",
        image: "hipaa2.png",
        fullForm: "Health Insurance Portability and Accountability Act (HIPAA)",
        description: "We implement stringent administrative, physical, and technical safeguards to protect electronic protected health information (ePHI) ensuring data confidentiality, integrity, and availability. "
    },
    {
        name: "PIPEDA Act",
        image: "pipeda-act.png",
        fullForm: "Personal Information Protection and Electronic Documents Act (PIPEDA)",
        description: "Our platform adheres to PIPEDA guidelines, ensuring that your data is protected and only used for its intended purpose."
    },
    {
        name: "EIDAS Act",
        image: "eidas.png",
        fullForm: "eIDAS (European Union)",
        description: "We comply with eIDAS by offering advanced electronic signatures that meet EU standards. Our platform ensures secure and legally binding transactions across all EU member states."
    },
    {
        name: "SOC 2 Type II",
        image: "soc2.png",
        fullForm: "SOC 2 (Service Organization Control 2)",
        description: "We adhere to SOC 2 criteria by implementing robust security measures, ensuring system availability, and maintaining data integrity. Our platform undergoes regular SOC 2 audits to verify that our controls are effective and meet industry standards. "
    },
    {
        name: "CCLA Act",
        image: "ccla-act.png",
        fullForm: "Contract and Commercial Law Act 2017 (CCLA)",
        description: "We provide transparent privacy policies and give users control over their personal data. Our platform allows users to opt out of the sale of their personal information, in compliance with CCLA."
    },
    {
        name: "ETA Act",
        image: "eta-act.png",
        fullForm: "Electronic Transactions Act 1999 (ETA)",
        description: "We align with the ETA by ensuring that electronic signatures on our platform are legally binding and that all electronic records are securely stored and easily accessible."
    },
    {
        name: "SOC Type 1",
        image: "soc1.png",
        fullForm: "SOC 1 (Service Organization Control 1)",
        description: "We undergo regular SOC 1 audits to demonstrate our commitment to secure and reliable financial reporting. Our internal controls are designed to protect client data and ensure the accuracy of financial transactions. "
    },
    {
        name: "GDPR",
        image: "gdpr.png",
        fullForm: "General Data Protection Regulation (GDPR)",
        description: "BoloSign ensures lawful, fair, and transparent data processing by obtaining explicit consent from users before collecting their data."
    },
    {
        name: "CCPA",
        image: "ccpa.png",
        fullForm: "California Consumer Privacy Act (CCPA)",
        description: "We provide a transparent privacy policy that informs users about their data rights under the CCPA. Our platform allows users to access and delete their personal information easily. "
    },
    {
        name: "ISO 27001",
        image: "iso.png",
        fullForm: "ISO (International Organization for Standardization)",
        description: "We follow ISO 27001 guidelines to establish, implement, maintain, and continually improve our information security management system (ISMS). "
    }
];
const Legal = (param)=>{
    let { bgColor ="bg-accent-blue" , shadow =true , complianceGroupImage =true  } = param;
    const [showLaws, setShowLaws] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showLawDescription, setShowLawDescription] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col sm:flex-row gap-6",
            children: [
                complianceGroupImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "shrink-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/ltd/legal-hero.png"),
                        alt: "Legal",
                        width: 120,
                        height: 120,
                        className: "w-[96px] sm:w-[120px] object-contain"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "sm:grow sm:w-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-2xl sm:text-3xl font-semibold text-gray-900",
                            children: "How does BoloSign’s legal compliance compare to industry leaders like DocuSign?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-5 text-gray-700 leading-relaxed",
                            children: "BoloSign fully complies with all major e-signature regulations, including the ESIGN Act, UETA, PIPEDA, UECA, ETA, and CCLA. Our platform adheres to the same rigorous legal standards as industry leaders, ensuring documents signed through BoloSign maintain full legal validity across jurisdictions."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 ".concat(showLaws ? "grid" : "hidden sm:grid"),
                            children: legals.map((legal)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative group bg-surface border border-surface-dark p-4 cursor-default rounded-md hover:cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: legal.local ? legal.image : "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/security/").concat(legal.image),
                                                    alt: legal.name,
                                                    width: 40,
                                                    height: 40,
                                                    className: "w-10 h-10 object-contain"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gray-900 font-medium",
                                                    children: legal.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute z-20 top-full left-0 mt-2 w-full rounded-lg bg-surface-dark text-gray-900 p-4 text-sm hidden group-hover:block transition-opacity duration-300 shadow-md ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "font-semibold",
                                                        children: [
                                                            legal.fullForm,
                                                            ":"
                                                        ]
                                                    }),
                                                    " ",
                                                    legal.description
                                                ]
                                            })
                                        })
                                    ]
                                }, legal.name))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-center sm:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: ()=>setShowLaws((prev)=>!prev),
                                className: "mt-6 px-6 py-3 bg-black text-white font-medium rounded-md",
                                children: showLaws ? "Hide All Laws" : "Show All Laws"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Legal);


/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 86585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const FaqCard = (param)=>{
    let { faqQuestion , faqAnswer , questionStyling , answerStyling  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: ()=>setIsOpen(!isOpen),
        className: "px-8 py-7 transition-all duration-300 border border-surface-dark rounded-2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: faqQuestion
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: faqAnswer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqCard);


/***/ }),

/***/ 35419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function SignUpForm(param) {
    let { phone =true  } = param;
    const [fullName, setFullName] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [phoneNumber, setPhoneNumber] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const handleSubmit = (e)=>{
        e.preventDefault();
        console.log("Form Data:", {
            fullName,
            phoneNumber,
            email
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "bg-white px-8 py-10 w-full border border-gray-200 rounded-2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-3xl font-semibold text-gray-900 mb-8",
                children: "Start Your Free Trial"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "fullName",
                        className: "block text-base font-medium text-gray-800 mb-2",
                        children: "Full Name *"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        id: "fullName",
                        required: true,
                        type: "text",
                        placeholder: "Enter your full name",
                        value: fullName,
                        onChange: (e)=>setFullName(e.target.value),
                        className: "block w-full border border-gray-300 px-4 py-3 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black outline-none rounded-md font-medium"
                    })
                ]
            }),
            phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "phoneNumber",
                        className: "block text-base font-medium text-gray-800 mb-2",
                        children: "Phone Number *"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        id: "phoneNumber",
                        type: "tel",
                        required: true,
                        placeholder: "+91 98765 43210",
                        value: phoneNumber,
                        onChange: (e)=>setPhoneNumber(e.target.value),
                        className: "block w-full border border-gray-300 px-4 py-3 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black outline-none rounded-md font-medium"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-sm text-gray-500 mt-2",
                        children: "You’ll receive an OTP on this number for verification."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "email",
                        className: "block text-base font-medium text-gray-800 mb-2",
                        children: "Email *"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        id: "email",
                        type: "email",
                        required: true,
                        placeholder: "you@example.com",
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        className: "block w-full border border-gray-300 px-4 py-3 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black outline-none rounded-md font-medium"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary1 */ .au, {
                buttonText: "Start Free Trial",
                className: "w-full",
                type: "submit"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SignUpForm);


/***/ }),

/***/ 93489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59183);
/* harmony import */ var components_SignatureLtd_Legal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33376);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);
/* harmony import */ var react_icons_tb__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37106);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86585);
/* harmony import */ var _components_Contracts_SignUpForm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35419);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74791);




// import Link from "next/link";







const features = [
    {
        image: "1.png",
        title: "Sign Documents Anytime, Anywhere",
        description: "BoloSign gives you the ability to let your clients sign documents from anywhere; they might be. This platform is so convenient for workers working remotely on simple or complex businesses. The platform is easy to use for every party involved—No more hassle just quick and hassle-free signing!"
    },
    {
        image: "2.png",
        title: "Affordable Plans for Every Business",
        description: 'We understand that small businesses search for services that are less expensive. That is why BoloSign includes <a href="https://www.boloforms.com/signature/pricing/" class="underline font-semibold">plans</a> that are within your budget yet with the features you need. You can easily upload, send, and electronically sign documents in your team, regardless of its size.'
    },
    {
        image: "3.png",
        title: "Secure and Legally-Binding Signatures",
        description: '<a href="https://security.boloforms.com/" class="underline font-semibold">Security</a> is an important factor in the world today. BoloSign is the solution offering a legally binding eSign option and it complies with <a href="https://www.boloforms.com/signature/electric-signature-legality/" class="underline font-semibold">ESIGN and UETA laws.</a> You will get a certificate of authentication for every document you send, which will give you peace of mind. Besides, you can add extra protection by asking recipients for a password. All your confidential data is safe with us!'
    },
    {
        image: "4.png",
        title: "Collaborate with your Team",
        description: "Collaborate effortlessly with your team using BoloSign – streamline document workflows, share, sign, and manage all in one place. Experience the best of free eSignatures with BoloSign – secure, simple, and perfect for every business need."
    },
    {
        image: "5.png",
        title: "Get Paid Faster",
        description: "Getting a document signed is good but having the document signed and paid for is way better! Once a document is signed with BoloSign, customers can complete the payment procedure immediately through our Stripe integration. It is a hassle-free process that will improve your cash flow with quicker returns."
    },
    {
        image: "6.png",
        title: "Easy Document Management",
        description: "No more jumping between apps to get your documents signed. With BoloSign, you can upload and sign PDFs, Word documents, Excel files, and even JPEGs—all in one place. It’s a flexible and affordable eSignature tool, designed especially for small businesses. Try BoloSign today and see how easy document signing can be!"
    }
];
const FaqData = [
    {
        question: "What is BoloSign’s Free eSignature Software?",
        answer: "BoloSign’s Free eSignature Software is a secure, legally binding electronic signature solution that allows you to sign documents anytime, anywhere. With our platform, you can quickly and easily get documents signed, collaborate with your team, and manage your documents efficiently, all for free!"
    },
    {
        question: "How secure are electronic signatures with BoloSign?",
        answer: "BoloSign ensures your electronic signatures are secure and legally binding by complying with ESIGN and UETA laws. Each signed document comes with a certificate of authentication, and you can add extra protection with password access, ensuring your confidential data remains safe."
    },
    {
        question: "Can I collaborate with my team using BoloSign?",
        answer: "Yes, BoloSign makes team collaboration simple by allowing you to share, review, and sign documents together in one place. Our platform streamlines the document workflow for teams of all sizes, making it ideal for small businesses and remote work environments."
    },
    {
        question: "Is there a free trial available for BoloSign’s eSignature service?",
        answer: "Yes, BoloSign offers a 7-day free trial of our eSignature service, which includes access to all features of the Business Plan. You can explore our platform at your own pace, with no commitment, and experience how it meets your eSignature needs."
    }
];
const ElectronicSignature = ()=>{
    // const router = useRouter();
    // const context = useContext(AppContext);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "What is an electronic signature? | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Electronic signatures refer to signatures in digital format, distinguishing them from traditional handwritten signatures. These digital signatures hold full legal validity for indicating consent or endorsement of document contents. The prevalence of eSignatures is progressively supplanting manual signatures, serving as a versatile method to sign a wide array of documents spanning various sectors on a global scale."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "eSignature, electronic signature, digital signature, eSign, eSignatures, electronic signatures, digital signatures, eSignature software, electronic signature software, digital signature software, eSignature solution, electronic signature solution, digital signature solution, eSignature app, electronic signature app, digital signature app, eSignature platform, electronic signature platform, digital signature platform, eSignature service, electronic signature service, digital signature service, eSignature tool, electronic signature tool, digital signature tool, eSignature online, electronic signature online, digital signature online, eSignature solution online, electronic signature solution online, digital signature solution online, eSignature software online, electronic signature software online, digital signature software online, eSignature platform online, electronic signature platform online, digital signature platform online"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/what-is-electronic-signature/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "What is an electronic signature? | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/what-is-electronic-signature/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "What is an electronic signature? | BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/what-is-electronic-signature/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex flex-col gap-24 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center gap-12 md:gap-20 md:px-8 px-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "Free Electronic Signature",
                                    paragraph: "Experience the best in secure and legally binding eSignatures with BoloSign, the ultimate free solution for small businesses. Try BoloSign's Free eSignature today and transform your document signing process!",
                                    buttonPrimaryText: "Start For Free",
                                    buttonPrimaryUrl: "",
                                    buttonPrimaryIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_10__/* .TbExternalLink */ .Ma9, {}),
                                    buttonPrimaryBg: "bg-black",
                                    buttonPrimaryBorderShadow: false
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: __webpack_require__(19607),
                                    // src={`${BASE_ASSETS_URL}/v2/gsuite/${image}`}
                                    className: "w-full h-auto",
                                    width: 50,
                                    height: 50,
                                    alt: "hero",
                                    priority: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-mxl mx-auto flex flex-col justify-center items-center sm:gap-12 px-4 lg:px-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex flex-col gap-12 sm:gap-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full flex flex-col gap-16",
                                children: features === null || features === void 0 ? void 0 : features.map((feature, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full flex flex-col justify-between items-center gap-4 sm:gap-20 ".concat(index % 2 === 0 ? "sm:flex-row-reverse" : "sm:flex-row"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full flex flex-col gap-4 sm:gap-6",
                                                children: [
                                                    feature.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                        className: "text-2xl sm:text-4xl lg:text-5xl",
                                                        children: feature.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-lg sm:text-xl lg:text-2xl",
                                                        dangerouslySetInnerHTML: {
                                                            __html: feature.description
                                                        }
                                                    })
                                                ]
                                            }),
                                            feature.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: __webpack_require__(86737)("./".concat(feature.image)),
                                                    // src={`${BASE_ASSETS_URL}/v2/gsuite/${feature.image}`}
                                                    className: "w-full h-auto",
                                                    width: 10,
                                                    height: 10,
                                                    loading: "lazy",
                                                    alt: ""
                                                })
                                            })
                                        ]
                                    }, index))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "w-full bg-surface-light py-16 sm:py-24 border-y-2 border-surface-dark",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full flex flex-col md:flex-row items-center gap-10 max-w-screen-xl mx-auto px-4 lg:px-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "max-w-screen-lg mx-auto text-3xl sm:text-4xl",
                                            children: "Explore the Features with a Free 7-Day Trial"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Contracts_SignUpForm__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                phone: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-lg sm:text-xl",
                                            children: "Enroll to our 7-day free trial now and check out why so many small business entities rely on BoloSign to cover their eSignature requirements."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: __webpack_require__(28018),
                                        className: "w-full h-auto",
                                        alt: "",
                                        width: 10,
                                        height: 10
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 lg:px-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureLtd_Legal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            faqData: FaqData,
                            heading: "Frequently Asked Questions"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ElectronicSignature);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8907,9774,2888,179], function() { return __webpack_exec__(38246); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);